/**
 * @generated SignedSource<<550d5eb750a3a56e9ea3704587c791df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventDetailShellQuery$variables = {
  eventID: string;
  memberId?: string | null | undefined;
};
export type EventDetailShellQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly unknownGuestsAllowed?: boolean | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"EventDetailBody" | "EventDetailHeader" | "EventDetailJoinEventSmall_event" | "EventDetailRedesignedHeader" | "EventDetailSignUpCard_event" | "EventDetailSignUpSection_event" | "EventDetailTitleRow" | "NewEventDetailBody" | "UpdateAttendeesGroupEventsModal_event" | "useInitEventForm_formQuestionConfiguration" | "useInitEventMeta_event" | "useInitEventSignUps_event" | "useInitGroupEvent_event">;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly id?: string;
      } | null | undefined;
    } | null | undefined;
    readonly user: {
      readonly squareCards?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly default: boolean;
            readonly id: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EventDetailShellQuery = {
  response: EventDetailShellQuery$data;
  variables: EventDetailShellQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SquareCardOnFileConnection",
      "kind": "LinkedField",
      "name": "squareCards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SquareCardOnFileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SquareCardOnFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "default",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberUser",
  "abstractKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Member",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "eventID"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownGuestsAllowed",
  "storageKey": null
},
v9 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v10 = [
  (v7/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v9/*: any*/)
],
v11 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v12 = {
  "alias": null,
  "args": (v11/*: any*/),
  "kind": "ScalarField",
  "name": "signUpStatusForClient",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": (v11/*: any*/),
  "kind": "ScalarField",
  "name": "accessStatusForClient",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spotsAvailable",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "singular",
    "storageKey": null
  },
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v23 = [
  (v18/*: any*/),
  (v1/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseBucket",
  "kind": "LinkedField",
  "name": "courseBucket",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = [
  (v18/*: any*/),
  (v24/*: any*/),
  (v1/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayTime",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closesAt",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opensAt",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelDeadlineAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelDeadlineDaysAhead",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancelDeadlineTime",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberControl",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDescription",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "EventRegistrationChargeType",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ChargeRuleSet",
      "kind": "LinkedField",
      "name": "chargeRuleSet",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v37/*: any*/),
        (v38/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ChargeRuleConnection",
          "kind": "LinkedField",
          "name": "chargeRules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChargeRuleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ChargeRule",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "duration",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "price",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "billingId",
                      "storageKey": null
                    },
                    (v39/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSignUpWindowChargesConnection",
  "kind": "LinkedField",
  "name": "charges",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSignUpWindowChargesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v36/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "staffControl",
          "storageKey": null
        },
        (v40/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "waitlistIndex",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkedIn",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "profileImage",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "payingMember",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unknownRegistrantDisplayName",
  "storageKey": null
},
v52 = [
  (v17/*: any*/),
  (v1/*: any*/)
],
v53 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PhoneNumber",
    "kind": "LinkedField",
    "name": "phoneNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nationalNumber",
        "storageKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "GOLF"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "departmentMemberProfiles",
    "plural": true,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ghinNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Department",
            "kind": "LinkedField",
            "name": "department",
            "plural": false,
            "selections": (v52/*: any*/),
            "storageKey": null
          }
        ],
        "type": "GolfMemberProfile",
        "abstractKey": null
      },
      (v1/*: any*/)
    ],
    "storageKey": "departmentMemberProfiles(type:\"GOLF\")"
  }
],
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "EventFormResponseConnection",
  "kind": "LinkedField",
  "name": "formResponses",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventFormResponseEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventFormResponse",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "booleanValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stringValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TransportationType",
              "kind": "LinkedField",
              "name": "transportationType",
              "plural": false,
              "selections": (v3/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FormQuestionConfiguration",
              "kind": "LinkedField",
              "name": "questionConfiguration",
              "plural": false,
              "selections": [
                (v54/*: any*/),
                (v1/*: any*/),
                (v31/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventDetailShellQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UpdateAttendeesGroupEventsModal_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailSignUpSection_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailHeader"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailRedesignedHeader"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailBody"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NewEventDetailBody"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useInitEventMeta_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useInitGroupEvent_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useInitEventSignUps_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useInitEventForm_formQuestionConfiguration"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailJoinEventSmall_event"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailTitleRow"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EventDetailSignUpCard_event"
              }
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventDetailShellQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v2/*: any*/),
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberHoldsAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacityType",
                "storageKey": null
              },
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSeries",
                "kind": "LinkedField",
                "name": "eventSeries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "supportsPublic",
                            "storageKey": null
                          },
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ClubCopyOverrides",
                            "kind": "LinkedField",
                            "name": "copyOverrides",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "NounOverride",
                                "kind": "LinkedField",
                                "name": "event",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "logoImage",
                            "plural": false,
                            "selections": (v19/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "eventPlayer",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "enabled",
                            "value": true
                          }
                        ],
                        "concreteType": "TransportationTypeConnection",
                        "kind": "LinkedField",
                        "name": "transportationTypes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TransportationTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TransportationType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "transportationTypes(enabled:true)"
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v18/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventConnection",
                    "kind": "LinkedField",
                    "name": "events",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endOn",
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "accessStatus",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": (v11/*: any*/),
                                "concreteType": "EventSignUp",
                                "kind": "LinkedField",
                                "name": "signUpForClient",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "status",
                                    "storageKey": null
                                  },
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startOn",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v22/*: any*/),
                                "concreteType": "EventTagConnection",
                                "kind": "LinkedField",
                                "name": "tags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventTagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventTag",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v23/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "tags(first:1000)"
                              },
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": (v22/*: any*/),
                                "concreteType": "EventSessionConnection",
                                "kind": "LinkedField",
                                "name": "eventSessions",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EventSessionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSession",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseConnection",
                                            "kind": "LinkedField",
                                            "name": "courses",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CourseEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Course",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v25/*: any*/),
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "kind": "LinkedField",
                                            "name": "event",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSeries",
                                                "kind": "LinkedField",
                                                "name": "eventSeries",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Facility",
                                                    "kind": "LinkedField",
                                                    "name": "facility",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "FacilityCopyOverrides",
                                                        "kind": "LinkedField",
                                                        "name": "copyOverrides",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "NounOverride",
                                                            "kind": "LinkedField",
                                                            "name": "course",
                                                            "plural": false,
                                                            "selections": (v16/*: any*/),
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      },
                                                      (v1/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v26/*: any*/),
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "eventSessions(first:1000)"
                              },
                              {
                                "alias": null,
                                "args": (v11/*: any*/),
                                "concreteType": "EventSignUpWindow",
                                "kind": "LinkedField",
                                "name": "clientEligibleSignUpWindows",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventSeries",
                                "kind": "LinkedField",
                                "name": "eventSeries",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v21/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Facility",
                                    "kind": "LinkedField",
                                    "name": "facility",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FacilityCopyOverrides",
                                        "kind": "LinkedField",
                                        "name": "copyOverrides",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "NounOverride",
                                            "kind": "LinkedField",
                                            "name": "course",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Department",
                                        "kind": "LinkedField",
                                        "name": "department",
                                        "plural": false,
                                        "selections": [
                                          (v31/*: any*/),
                                          (v18/*: any*/),
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v32/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "published",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpWindowConnection",
                "kind": "LinkedField",
                "name": "signUpWindows",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindow",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v1/*: any*/),
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRegistrationChargeTypeConnection",
                "kind": "LinkedField",
                "name": "primaryRegistrationChargeTypes",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationChargeTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v40/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v42/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "EventSignUp",
                "kind": "LinkedField",
                "name": "signUpForClient",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindow",
                    "kind": "LinkedField",
                    "name": "signUpWindow",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canDelete",
                    "storageKey": null
                  },
                  (v44/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "ownerClient",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": "memberOwnerId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/)
                        ],
                        "type": "Member",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/)
                        ],
                        "type": "Customer",
                        "abstractKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventRegistrationConnection",
                    "kind": "LinkedField",
                    "name": "registrations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventRegistrationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v1/*: any*/),
                              (v31/*: any*/),
                              (v49/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/)
                                ],
                                "type": "MemberEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v50/*: any*/),
                                  (v51/*: any*/)
                                ],
                                "type": "GuestEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Customer",
                                    "kind": "LinkedField",
                                    "name": "payingCustomer",
                                    "plural": false,
                                    "selections": (v3/*: any*/),
                                    "storageKey": null
                                  },
                                  (v51/*: any*/)
                                ],
                                "type": "CustomerEventRegistration",
                                "abstractKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationChargeType",
                                "kind": "LinkedField",
                                "name": "primaryChargeType",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChargeRuleSet",
                                    "kind": "LinkedField",
                                    "name": "chargeRuleSet",
                                    "plural": false,
                                    "selections": [
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v1/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "registrant",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v1/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v48/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v53/*: any*/),
                                    "type": "Member",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v53/*: any*/),
                                    "type": "Customer",
                                    "abstractKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "email",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minMemberCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minGuestCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryChargeType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "memberSignUpProxyAllowed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpWindowChargesConnection",
                    "kind": "LinkedField",
                    "name": "charges",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUpWindowChargesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          (v36/*: any*/),
                          (v40/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "closeDaysAhead",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "closeTime",
                    "storageKey": null
                  },
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "openTime",
                    "storageKey": null
                  },
                  (v30/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "allowedGroupSizes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWaitlist",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormConfiguration",
                "kind": "LinkedField",
                "name": "formConfiguration",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FormQuestionConfigurationConnection",
                    "kind": "LinkedField",
                    "name": "formQuestionConfigurations",
                    "plural": false,
                    "selections": [
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FormQuestionConfigurationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormQuestionConfiguration",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "guestVisibility",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "memberVisibility",
                                "storageKey": null
                              },
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "placeholder",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "prompt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "target",
                                "storageKey": null
                              },
                              (v31/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "eligibleWindowsForCharges",
                "args": null,
                "concreteType": "EventSignUpWindow",
                "kind": "LinkedField",
                "name": "clientEligibleSignUpWindows",
                "plural": true,
                "selections": [
                  (v41/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "prePaymentRequirement",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSignUpConnection",
                "kind": "LinkedField",
                "name": "signUps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "ownerClient",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationConnection",
                            "kind": "LinkedField",
                            "name": "registrations",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "registrant",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attendeeListVisible",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "limitSeriesSignUps",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "capacity",
                "storageKey": null
              },
              {
                "alias": "eventSignUps",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "waitlist",
                    "value": false
                  }
                ],
                "concreteType": "EventSignUpConnection",
                "kind": "LinkedField",
                "name": "signUps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSignUpEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSignUp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventRegistrationConnection",
                            "kind": "LinkedField",
                            "name": "registrations",
                            "plural": false,
                            "selections": [
                              (v42/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventRegistrationEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v1/*: any*/),
                                      (v31/*: any*/),
                                      (v49/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "registrant",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          (v1/*: any*/),
                                          (v45/*: any*/),
                                          (v46/*: any*/),
                                          (v48/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v55/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v43/*: any*/),
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BookingConnection",
                            "kind": "LinkedField",
                            "name": "bookings",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BookingEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v1/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isBooking"
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "RoundConnection",
                                        "kind": "LinkedField",
                                        "name": "rounds",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "RoundEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v7/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "player",
                                                    "plural": false,
                                                    "selections": [
                                                      (v7/*: any*/),
                                                      (v1/*: any*/),
                                                      (v45/*: any*/),
                                                      (v46/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isRound"
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TransportationType",
                                                    "kind": "LinkedField",
                                                    "name": "transportationType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v20/*: any*/),
                                                      (v1/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseLayout",
                                                    "kind": "LinkedField",
                                                    "name": "courseLayout",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "holeCount",
                                                        "storageKey": null
                                                      },
                                                      (v1/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "startSlot",
                                        "plural": false,
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "time",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Course",
                                                "kind": "LinkedField",
                                                "name": "course",
                                                "plural": false,
                                                "selections": (v25/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSlot",
                                                "kind": "LinkedField",
                                                "name": "eventSlot",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "EventSession",
                                                    "kind": "LinkedField",
                                                    "name": "eventSession",
                                                    "plural": false,
                                                    "selections": (v3/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v1/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "TimeSlot",
                                            "abstractKey": null
                                          },
                                          (v1/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "signUps(waitlist:false)"
              },
              {
                "alias": null,
                "args": (v22/*: any*/),
                "concreteType": "EventSessionConnection",
                "kind": "LinkedField",
                "name": "eventSessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSessionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSession",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "durationMins",
                            "storageKey": null
                          },
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseConnection",
                            "kind": "LinkedField",
                            "name": "courses",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Course",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v18/*: any*/),
                                      (v24/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agenda",
                            "kind": "LinkedField",
                            "name": "agenda",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hostsVisible",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventSeries",
                                "kind": "LinkedField",
                                "name": "eventSeries",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v1/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StaffProfileConnection",
                                "kind": "LinkedField",
                                "name": "hosts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StaffProfileEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StaffProfile",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v1/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StaffUser",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v45/*: any*/),
                                              (v46/*: any*/),
                                              (v47/*: any*/),
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v48/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventSessions(first:1000)"
              },
              {
                "alias": "firstEventSession",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "EventSessionConnection",
                "kind": "LinkedField",
                "name": "eventSessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSessionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventSession",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agenda",
                            "kind": "LinkedField",
                            "name": "agenda",
                            "plural": false,
                            "selections": [
                              (v56/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": (v52/*: any*/),
                                "storageKey": null
                              },
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "eventSessions(first:1)"
              },
              (v39/*: any*/)
            ],
            "type": "Event",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bc7192ce44e3fa8f32c8be69fe703a7a",
    "id": null,
    "metadata": {},
    "name": "EventDetailShellQuery",
    "operationKind": "query",
    "text": "query EventDetailShellQuery(\n  $eventID: ID!\n  $memberId: ID\n) {\n  session {\n    user {\n      __typename\n      ... on MemberUser {\n        squareCards {\n          edges {\n            node {\n              id\n              default\n            }\n          }\n        }\n      }\n      id\n    }\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Member {\n          id\n        }\n        ... on Customer {\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  node(id: $eventID) {\n    id\n    __typename\n    ... on Event {\n      id\n      unknownGuestsAllowed\n      ...UpdateAttendeesGroupEventsModal_event\n      ...EventDetailSignUpSection_event\n      ...EventDetailHeader\n      ...EventDetailRedesignedHeader\n      ...EventDetailBody\n      ...NewEventDetailBody\n      ...useInitEventMeta_event\n      ...useInitGroupEvent_event\n      ...useInitEventSignUps_event\n      ...useInitEventForm_formQuestionConfiguration\n      ...EventDetailJoinEventSmall_event\n      ...EventDetailTitleRow\n      ...EventDetailSignUpCard_event\n    }\n  }\n}\n\nfragment ActionButtonsEventSignUp_event on Event {\n  ...useGetPrimaryChargeNameAndPrice_event\n  allowedGroupSizes\n  signUpWindows {\n    edges {\n      node {\n        cancelDeadlineAt\n        cancelDeadlineDaysAhead\n        cancelDeadlineTime\n        id\n      }\n    }\n  }\n}\n\nfragment AddOrEditSignUp_event on Event {\n  ...useInitializeEventSignUpProcess_event\n  ...FormStepManager_event\n  ...ActionButtonsEventSignUp_event\n}\n\nfragment ClubLogo_Club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment EventCardWrapper_Event on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  accessStatus\n  signUpStatusForClient(clientId: $memberId)\n  signUpForClient(clientId: $memberId) {\n    status\n    id\n  }\n  startOn\n  endOn\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  spotsAvailable\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        ...useEventLocationLabel_Event\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    id\n    closesAt\n    opensAt\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment EventDateTimeLocationBar_eventSession on EventSession {\n  durationMins\n  startAt\n  endAt\n  displayTime\n  courses {\n    edges {\n      node {\n        id\n        name\n        courseBucket {\n          name\n          id\n        }\n      }\n    }\n  }\n  agenda {\n    date\n    id\n  }\n}\n\nfragment EventDetailActions_event on Event {\n  id\n  memberSignUpProxyAllowed\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  unknownGuestsAllowed\n  eventSeries {\n    name\n    facility {\n      id\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    closeDaysAhead\n    closeTime\n    closesAt\n    openTime\n    opensAt\n    cancelDeadlineAt\n    cancelDeadlineDaysAhead\n    cancelDeadlineTime\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  ...useCurrentSignUp_event\n}\n\nfragment EventDetailAttendeesGroupListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesList on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  spotsAvailable\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  capacity\n  hasWaitlist\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...EventDetailAttendeesListItemFragment\n        ...EventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventDetailAttendeesListItemFragment on EventSignUp {\n  waitlistIndex\n  id\n  checkedIn\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        index\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n        formResponses {\n          edges {\n            node {\n              id\n              booleanValue\n              stringValue\n              transportationType {\n                id\n              }\n              questionConfiguration {\n                enabled\n                id\n                type\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailBody on Event {\n  ...EventDetailAttendeesList\n  ...EventDetailGroupDisplay_event\n  ...EventDetailMultiSessionEventDisplay_event\n  ...EventDetailSeriesInfo_event\n  ...EventDetailPairings_event\n  description\n  spotsAvailable\n  signUpStatusForClient(clientId: $memberId)\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        ...EventDetailHosts\n        ...EventDetailInfo_eventSession\n        id\n      }\n    }\n  }\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  capacity\n  allowedGroupSizes\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...EventDetailAttendeesListItemFragment\n        ...EventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n  eventSeries {\n    image {\n      publicId: renderingKey\n    }\n    color\n    published\n    id\n  }\n}\n\nfragment EventDetailCapacity_event on Event {\n  capacity\n  spotsAvailable\n  capacityType\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailGroupDisplay_event on Event {\n  ...useCurrentSignUp_event\n  id\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  primaryChargeType\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailHeader on Event {\n  id\n  eventSeries {\n    name\n    color\n    facility {\n      name\n      club {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventDetailHosts on EventSession {\n  event {\n    hostsVisible\n    eventSeries {\n      color\n      id\n    }\n    hosts {\n      edges {\n        node {\n          id\n          user {\n            firstName\n            lastName\n            fullName\n            id\n          }\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailInfo_eventSession on EventSession {\n  durationMins\n  startAt\n  endAt\n  displayTime\n  courses {\n    edges {\n      node {\n        id\n        name\n        courseBucket {\n          name\n          id\n        }\n      }\n    }\n  }\n  agenda {\n    date\n    id\n  }\n}\n\nfragment EventDetailJoinEventSmall_event on Event {\n  signUpStatusForClient(clientId: $memberId)\n  signUps {\n    edges {\n      node {\n        id\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  memberSignUpProxyAllowed\n  ...EventDetailJoinEvent_event\n}\n\nfragment EventDetailJoinEvent_event on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  prePaymentRequirement\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  unknownGuestsAllowed\n  memberSignUpProxyAllowed\n  minGuestCount\n  signUps {\n    edges {\n      node {\n        id\n        registrations {\n          edges {\n            node {\n              __typename\n              id\n              registrant {\n                __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  eventSeries {\n    name\n    facility {\n      id\n      club {\n        slug\n        id\n      }\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    closeDaysAhead\n    closeTime\n    closesAt\n    openTime\n    opensAt\n    cancelDeadlineAt\n    cancelDeadlineDaysAhead\n    cancelDeadlineTime\n    id\n  }\n}\n\nfragment EventDetailMultiSessionDateDisplay_event on Event {\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        id\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        agenda {\n          date\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment EventDetailMultiSessionEventDisplay_event on Event {\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        id\n        ...EventDetailInfo_eventSession\n      }\n    }\n  }\n  capacity\n  allowedGroupSizes\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment EventDetailPairingItem_booking on Booking {\n  __isBooking: __typename\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          id\n        }\n        ...EventDetailPairingsRound_round\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      time\n      course {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n      eventSlot {\n        eventSession {\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailPairingsRound_round on Round {\n  __isRound: __typename\n  player {\n    __typename\n    id\n    firstName\n    lastName\n  }\n  transportationType {\n    code\n    id\n  }\n  courseLayout {\n    holeCount\n    id\n  }\n}\n\nfragment EventDetailPairings_event on Event {\n  id\n  firstEventSession: eventSessions(first: 1) {\n    edges {\n      node {\n        startAt\n        agenda {\n          date\n          facility {\n            slug\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          edges {\n            node {\n              __typename\n              registrant {\n                __typename\n                id\n              }\n              id\n            }\n          }\n        }\n        bookings {\n          edges {\n            node {\n              __typename\n              id\n              ...EventDetailPairingItem_booking\n            }\n          }\n        }\n        ...EventDetailAttendeesListItemFragment\n        ...EventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment EventDetailPricingSection_event on Event {\n  primaryChargeType\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailRedesignedHeader on Event {\n  eventSeries {\n    facility {\n      club {\n        name\n        ...ClubLogo_Club\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventDetailSeriesInfoBanner on Event {\n  limitSeriesSignUps\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n}\n\nfragment EventDetailSeriesInfo_event on Event {\n  id\n  eventSeries {\n    facility {\n      club {\n        copyOverrides {\n          event {\n            plural\n          }\n        }\n        id\n      }\n      id\n    }\n    events {\n      edges {\n        node {\n          id\n          endOn\n          ...EventCardWrapper_Event\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailSeriesNavButtons_event on Event {\n  id\n  eventSeries {\n    facility {\n      club {\n        copyOverrides {\n          event {\n            singular\n            plural\n          }\n        }\n        id\n      }\n      id\n    }\n    events {\n      edges {\n        node {\n          id\n          endOn\n          ...EventCardWrapper_Event\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailSignUpCard_event on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  primaryChargeType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  unknownGuestsAllowed\n  memberSignUpProxyAllowed\n  signUps {\n    edges {\n      node {\n        id\n        registrations {\n          edges {\n            node {\n              __typename\n              id\n              registrant {\n                __typename\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  eventSeries {\n    name\n    facility {\n      id\n      club {\n        slug\n        id\n      }\n    }\n    id\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    closeDaysAhead\n    closeTime\n    closesAt\n    openTime\n    opensAt\n    cancelDeadlineAt\n    cancelDeadlineDaysAhead\n    cancelDeadlineTime\n    charges {\n      edges {\n        memberControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  price\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventDetailSignUpSection_event on Event {\n  signUpStatusForClient(clientId: $memberId)\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  signUps {\n    edges {\n      node {\n        id\n        ownerClient {\n          __typename\n          ... on Member {\n            id\n          }\n          ... on Customer {\n            id\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  memberSignUpProxyAllowed\n  attendeeListVisible\n  ...EventDetailPricingSection_event\n  ...EventDetailJoinEvent_event\n  ...EventDetailSignUpCard_event\n  ...EventDetailGroupDisplay_event\n  ...EventDetailSeriesInfoBanner\n  ...EventDetailActions_event\n  ...EventDetailYourSignup_event\n  ...EventDetailAttendeesList\n  ...NewEventDetailAttendeesList\n}\n\nfragment EventDetailTitleRow on Event {\n  eventSeries {\n    name\n    color\n    id\n  }\n}\n\nfragment EventDetailYourSignup_event on Event {\n  ...useCurrentSignUp_event\n  id\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventFormStep_event on Event {\n  maxGuestCount\n  maxMemberCount\n  minGuestCount\n  minMemberCount\n  eventSeries {\n    facility {\n      club {\n        copyOverrides {\n          event {\n            singular\n          }\n        }\n        id\n      }\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      transportationTypes(enabled: true) {\n        edges {\n          node {\n            id\n            code\n            customCode\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment EventSignUpPrimaryChargePaymentAssignment_event on Event {\n  ...useGetPrimaryChargeNameAndPrice_event\n  memberSignUpProxyAllowed\n  prePaymentRequirement\n}\n\nfragment FormStepManager_event on Event {\n  ...GroupRegistrationDisplay_event\n  ...EventFormStep_event\n  ...PrimaryChargeSelectionStep_event\n  ...EventSignUpPrimaryChargePaymentAssignment_event\n  primaryChargeType\n  prePaymentRequirement\n  spotsAvailable\n  memberSignUpProxyAllowed\n  capacityType\n  maxMemberCount\n  maxGuestCount\n  allowedGroupSizes\n}\n\nfragment GroupRegistrationDisplay_event on Event {\n  spotsAvailable\n  capacityType\n  allowedGroupSizes\n  minGuestCount\n  minMemberCount\n  maxGuestCount\n  maxMemberCount\n  memberSignUpProxyAllowed\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment NewEventDetailAttendeesGroupListItemFragment on EventSignUp {\n  id\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NewEventDetailAttendeesList on Event {\n  id\n  capacityType\n  maxGuestCount\n  maxMemberCount\n  minMemberCount\n  minGuestCount\n  eventSeries {\n    facility {\n      copyOverrides {\n        eventPlayer {\n          singular\n        }\n      }\n      id\n    }\n    id\n  }\n  eventSignUps: signUps(waitlist: false) {\n    edges {\n      node {\n        id\n        registrations {\n          count\n        }\n        ...NewEventDetailAttendeesListItemFragment\n        ...NewEventDetailAttendeesGroupListItemFragment\n      }\n    }\n  }\n}\n\nfragment NewEventDetailAttendeesListItemFragment on EventSignUp {\n  id\n  registrations {\n    edges {\n      node {\n        __typename\n        id\n        type\n        registrant {\n          __typename\n          id\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment NewEventDetailBody on Event {\n  ...EventDetailSeriesNavButtons_event\n  ...EventDetailPairings_event\n  ...EventDetailTitleRow\n  ...EventDetailMultiSessionDateDisplay_event\n  ...EventDetailCapacity_event\n  description\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        ...EventDateTimeLocationBar_eventSession\n        ...EventDetailHosts\n        id\n      }\n    }\n  }\n  eventSeries {\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment PrimaryChargeSelectionStep_event on Event {\n  id\n  ...useGetAllPrimaryChargeSelectionOptions_event\n  primaryChargeType\n  prePaymentRequirement\n}\n\nfragment UpdateAttendeesGroupEventsModal_event on Event {\n  id\n  signUpStatusForClient(clientId: $memberId)\n  accessStatusForClient(clientId: $memberId)\n  unknownGuestsAllowed\n  memberHoldsAllowed\n  capacityType\n  spotsAvailable\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      copyOverrides {\n        eventPlayer {\n          singular\n          plural\n        }\n      }\n      id\n    }\n    id\n  }\n  signUpWindows {\n    edges {\n      node {\n        cancelDeadlineAt\n        cancelDeadlineDaysAhead\n        cancelDeadlineTime\n        id\n      }\n    }\n  }\n  primaryRegistrationChargeTypes {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ...EventDetailGroupDisplay_event\n  ...useInitEventSignUpPrimaryChargeInfo_event\n  ...AddOrEditSignUp_event\n}\n\nfragment useCurrentSignUp_event on Event {\n  signUpForClient(clientId: $memberId) {\n    signUpWindow {\n      cancelDeadlineAt\n      id\n    }\n    waitlistIndex\n    id\n    canDelete\n    checkedIn\n    ownerClient {\n      __typename\n      ... on Member {\n        id\n        memberOwnerId: id\n        firstName\n        lastName\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Customer {\n        id\n        fullName\n        profileImage {\n          publicId: renderingKey\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    registrations {\n      edges {\n        node {\n          __typename\n          id\n          type\n          index\n          ... on MemberEventRegistration {\n            payingMember {\n              id\n            }\n          }\n          ... on GuestEventRegistration {\n            payingMember {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          ... on CustomerEventRegistration {\n            payingCustomer {\n              id\n            }\n            unknownRegistrantDisplayName\n          }\n          primaryChargeType {\n            id\n            chargeRuleSet {\n              displayName\n              displayDescription\n              id\n            }\n          }\n          registrant {\n            __typename\n            id\n            firstName\n            lastName\n            profileImage {\n              publicId: renderingKey\n            }\n            ... on Member {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            ... on Customer {\n              phoneNumber {\n                nationalNumber\n                id\n              }\n              departmentMemberProfiles(type: GOLF) {\n                __typename\n                ... on GolfMemberProfile {\n                  ghinNumber\n                  department {\n                    slug\n                    id\n                  }\n                }\n                id\n              }\n            }\n            email\n          }\n          formResponses {\n            edges {\n              node {\n                id\n                booleanValue\n                stringValue\n                transportationType {\n                  id\n                }\n                questionConfiguration {\n                  enabled\n                  id\n                  type\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useGetAllPrimaryChargeSelectionOptions_event on Event {\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                displayDescription\n                chargeRules {\n                  edges {\n                    node {\n                      price\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useGetPrimaryChargeNameAndPrice_event on Event {\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                chargeRules {\n                  edges {\n                    node {\n                      price\n                      id\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            chargeRules {\n              edges {\n                node {\n                  price\n                  id\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment useInitEventForm_formQuestionConfiguration on Event {\n  formConfiguration {\n    id\n    formQuestionConfigurations {\n      edges {\n        node {\n          id\n          prompt\n          type\n          guestVisibility\n          memberVisibility\n          values\n          enabled\n          shortName\n          target\n        }\n      }\n    }\n  }\n}\n\nfragment useInitEventMeta_event on Event {\n  id\n  capacity\n  spotsAvailable\n  hasWaitlist\n  accessStatusForClient(clientId: $memberId)\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    cancelDeadlineAt\n    id\n  }\n  memberSignUpProxyAllowed\n}\n\nfragment useInitEventSignUpPrimaryChargeInfo_event on Event {\n  maxMemberCount\n  minMemberCount\n  maxGuestCount\n  minGuestCount\n  primaryChargeType\n  primaryRegistrationChargeTypes {\n    edges {\n      node {\n        chargeRuleSet {\n          id\n          displayName\n          displayDescription\n          chargeRules {\n            edges {\n              node {\n                id\n                duration\n                price\n                billingId\n                description\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useInitEventSignUps_event on Event {\n  memberSignUpProxyAllowed\n  ...useCurrentSignUp_event\n  signUpStatusForClient(clientId: $memberId)\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useInitGroupEvent_event on Event {\n  maxMemberCount\n  minMemberCount\n  maxGuestCount\n  minGuestCount\n  allowedGroupSizes\n}\n\nfragment useInitializeEventSignUpProcess_event on Event {\n  id\n  maxGuestCount\n  maxMemberCount\n  minGuestCount\n  minMemberCount\n  allowedGroupSizes\n  memberSignUpProxyAllowed\n  hasWaitlist\n  capacityType\n  spotsAvailable\n  eventSeries {\n    facility {\n      club {\n        supportsPublic\n        id\n      }\n      id\n    }\n    id\n  }\n  formConfiguration {\n    id\n    formQuestionConfigurations {\n      count\n      edges {\n        node {\n          id\n          enabled\n          guestVisibility\n          memberVisibility\n          description\n          placeholder\n          prompt\n          shortName\n          target\n          type\n          values\n        }\n      }\n    }\n  }\n  primaryChargeType\n  primaryRegistrationChargeTypes {\n    count\n  }\n  signUpWindows {\n    edges {\n      node {\n        charges {\n          edges {\n            memberControl\n            staffControl\n            node {\n              id\n              chargeRuleSet {\n                id\n                displayName\n                displayDescription\n                chargeRules {\n                  edges {\n                    node {\n                      id\n                      duration\n                      price\n                      billingId\n                      description\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  eligibleWindowsForCharges: clientEligibleSignUpWindows {\n    charges {\n      edges {\n        memberControl\n        staffControl\n        node {\n          id\n          chargeRuleSet {\n            id\n            displayName\n            displayDescription\n            chargeRules {\n              edges {\n                node {\n                  id\n                  duration\n                  price\n                  billingId\n                  description\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "40c118455836c1c88e4296c218839f30";

export default node;
